<script lang="ts">
  // Svelte 5 native error boundary using <svelte:boundary>.
  // Wraps any child block; on uncaught render error or async failure, shows the
  // fallback. Useful for catching Three.js context loss, worker crashes, etc.
  interface Props {
    children?: import('svelte').Snippet;
    failed?: import('svelte').Snippet<[unknown, () => void]>;
  }
  const { children, failed }: Props = $props();
</script>

<svelte:boundary>
  {@render children?.()}
  {#snippet failed(err, reset)}
    <div class="boundary">
      <div class="ms">error</div>
      <h3>Beklenmedik bir hata oluştu</h3>
      <p class="msg">{err instanceof Error ? err.message : String(err)}</p>
      <div class="actions">
        <button onclick={reset}>Tekrar Dene</button>
        <button class="ghost" onclick={() => location.reload()}>Sayfayı Yenile</button>
      </div>
    </div>
  {/snippet}
</svelte:boundary>

<style>
  .boundary {
    padding: 20px; background: rgba(208, 74, 58, 0.08);
    border: 1px solid rgba(208, 74, 58, 0.3); border-radius: 8px;
    color: var(--text-1); display: flex; flex-direction: column; gap: 8px;
    align-items: center; text-align: center; max-width: 480px; margin: 20px auto;
  }
  .boundary .ms { font-size: 36px; color: #ff6b5a; }
  h3 { margin: 0; font-size: 14px; }
  .msg {
    margin: 0; font-size: 12px; color: var(--text-3);
    font-family: ui-monospace, monospace;
    background: var(--bg-viewer-from); padding: 6px 10px;
    border-radius: 4px; max-width: 100%; word-break: break-word;
  }
  .actions { display: flex; gap: 6px; margin-top: 4px; }
  button {
    background: var(--accent); color: white; border: none;
    padding: 6px 14px; border-radius: 6px; font-family: inherit;
    font-size: 12px; cursor: pointer;
  }
  button.ghost { background: var(--chip-bg); color: var(--text-2); border: 1px solid var(--border-soft); }
</style>
